export const IS_CHINA_CRORSS_ITEMS = {
  parcel_goods_code: '',
  parcel_goods_name: '',
  parcel_goods_cname: '',
  parcel_goods_ename: '',
  parcel_goods_hscode: '',
  parcel_goods_quantity: 1,
  parcel_goods_price: 1,
}

export const IS_CRORSS_BORDER_ITEMS = {
  parcel_goods_code: '',
  parcel_goods_name: '',
  parcel_goods_ename: '',
  parcel_goods_hscode: '',
  parcel_goods_quantity: 1,
  parcel_goods_price: 1,
}

export const NORMAL_ITEMS = {
  parcel_goods_code: '',
  parcel_goods_name: '',
  parcel_goods_quantity: 1,
  parcel_goods_price: 1,
}

type Size = 'cm'

export const SIZE: Record<Size, string> = {
  cm: 'cm',
}

export const CONTENT = {
  add: {
    title: 'parcel.add.product',
    okText: 'newOrder.add',
  },
  edit: {
    title: 'parcel.item.edit',
    okText: 'newOrder.save',
  },
}
